interface ApiErrorComponentProps {
  isError?: boolean;
  errorRespnse?: any;
}

const getError = (data: any) => {
  if (data) {
    if (typeof data === 'string' || data instanceof String) {
      return data;
    }
    if (data.message) {
      return data.message;
    }
    if (data.title) {
      return data.title;
    }
  }
  return 'Unknwon error. Please contact admin.';
};

export const ApiErrorComponent = ({ isError, errorRespnse }: ApiErrorComponentProps) => {
  if (!isError && !errorRespnse) {
    return null;
  }

  const {
    response: { data },
  } = errorRespnse ?? { response: {} };

  const error = getError(data);

  return <div className="api-error alert alert-danger alert-sm pt-1 pb-1  w-100 text-center">{error}</div>;
};
